import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { useSEO, useSchema } from '../../utils/seo';

export default function Mining() {
  useSEO({
    title: 'Mining & Passive Tools - Cloud Mining und passive Einnahmen | EarnProof',
    description: 'Getestete Cloud-Mining Apps und passive Income Tools. GoMining und Bitcoin Miner im Test mit echten Einnahmen von ca. 250€. 12 Monate Erfahrung.',
    keywords: 'cloud mining, bitcoin mining, passive income, gomining, bitcoin miner, crypto mining apps, passive einnahmen',
    canonical: 'https://example.com/mining',
  });

  useSchema({
    type: 'Article',
    data: {
      headline: 'Mining & Passive Tools - Getestete Cloud-Mining Apps',
      description: 'Ehrliche Tests von Cloud-Mining Plattformen mit echten Einnahmen-Nachweisen',
      author: {
        '@type': 'Person',
        name: 'Christopher Humpert',
      },
      publisher: {
        '@type': 'Organization',
        name: 'EarnProof',
        logo: {
          '@type': 'ImageObject',
          url: 'https://example.com/logo.png',
        },
      },
      datePublished: '2025-01-15',
      dateModified: '2025-01-15',
    },
  });

  const [selectedApp, setSelectedApp] = useState<any>(null);
  const [showDetailModal, setShowDetailModal] = useState(false);

  const testedApps = [
    {
      name: 'GoMining',
      category: 'Cloud Mining',
      rating: 4.1,
      earnings: 'ca. 200€',
      status: 'verified',
      type: 'Cloud Mining',
      image: 'https://static.readdy.ai/image/50172c35d199b0f1b57a44755da07512/86454e1e35e4fdacab9474e036b6f596.png',
      description: 'GoMining ist eine Cloud-Mining-Plattform, die es ermöglicht, Kryptowährungen wie Bitcoin und Ethereum zu minen, ohne eigene Hardware zu besitzen. Die Plattform bietet verschiedene Mining-Pakete und automatische Auszahlungen.',
      testResult: 'Nach 6 Monaten Test: Stabile Auszahlungen, transparente Gebührenstruktur. Mining-Erträge schwanken je nach Krypto-Markt, aber Plattform ist zuverlässig.',
      payoutProof: true,
      difficulty: 'Einfach',
      setup: '15 Minuten',
      requirements: [
        'Verifiziertes Konto erforderlich',
        'Krypto-Wallet für Auszahlungen',
        'Grundverständnis für Kryptowährungen'
      ],
      pros: [
        'Keine eigene Hardware nötig',
        'Automatische Auszahlungen',
        'Verschiedene Kryptowährungen',
        'Transparente Gebühren',
        'Mobile App verfügbar'
      ],
      cons: [
        'Investition erforderlich',
        'Abhängig von Krypto-Preisen',
        'Mining-Schwierigkeit schwankt',
        'Langfristige Rentabilität unsicher',
        'Gebühren reduzieren Gewinn'
      ],
      detailedReview: {
        setup: 'Die Registrierung bei GoMining läuft absolut unkompliziert ab – Verifizierung per Ausweis, direkt einsteigen, fertig. Bereits ab 50 € bist du dabei, kannst aber auch sofort größere Pakete kaufen und dein Mining-Level selbst bestimmen. Zahlungsmethoden sind vielfältig, die Plattform ist auf deutsch & englisch super erklärt.',
        earnings: 'Was mit kleinen Beträgen startet, kannst du jederzeit flexibel skalieren. Richtig spannend wird\'s, wenn du mehr investierst: Wer z. B. mit 500 €, 1.000 € oder mehr einsteigt, sieht die wahren Vorteile von Cloud-Mining:\n\n• Tägliche, vollautomatische Auszahlungen auf die eigene Wallet\n• Skalierbare Erträge: Je höher dein Investment, desto höher die täglichen Einnahmen\n• Volle Kontrolle & Übersicht über alle Einnahmen, jederzeit einsehbar im Dashboard\n\nSelbst bei schwankenden Krypto-Preisen bleibt GoMining stabil – und mit regelmäßigen Reinvestitionen kannst du das Wachstum deiner Erträge noch weiter beschleunigen.',
        payout: 'Auszahlungen laufen vollautomatisch ab 0,001 BTC – ohne manuelles Eingreifen, direkt und zuverlässig. Die Plattform zeigt dir transparent alle Gebühren und Renditen an. Ich habe alle Auszahlungen pünktlich in voller Höhe erhalten – so macht passives Krypto-Investment wirklich Spaß.',
        tips: '• Starte mit dem Betrag, der zu dir passt und taste dich ran – von 50 € bis mehrere Tausend ist alles möglich\n• Reinvestiere einen Teil der Gewinne für exponentielles Wachstum\n• Nutze die günstigen Einstiegsphasen bei schwachen Krypto-Kursen, um langfristig zu profitieren\n• Behalte die Mining-Schwierigkeit im Auge: Wer früh startet, hat oft den größten Vorteil!',
        conclusion: 'GoMining ist für mich die Empfehlung für alle, die echtes passives Einkommen im Krypto-Bereich aufbauen wollen – egal ob Einsteiger oder erfahrener Investor.\n\nMit niedrigen Hürden, maximaler Transparenz und automatisierten Auszahlungen ist GoMining der einfachste Weg, von Krypto-Mining zu profitieren – und bei entsprechendem Investment sind hier auch mehrere hundert Euro pro Monat drin.\n\nTest it, scale it, own it!\nStarte jetzt – und sichere dir deinen Anteil am nächsten großen Krypto-Boom!'
      }
    },
    {
      name: 'Bitcoin Miner - Code: 2UNE5W',
      category: 'Cloud Mining',
      rating: 3.2,
      earnings: '50€',
      status: 'active',
      type: 'Cloud Mining',
      image: 'https://public.readdy.ai/ai/img_res/3eda7f0faf590cb15db40f75fc21c27e.jpg',
      description: 'Bitcoin Miner ist eine Cloud-Mining-App, die passives Bitcoin-Mining ermöglicht. Achtung: Die App wurde aus dem Play Store entfernt und ist nur noch als APK verfügbar – Nutzung auf eigenes Risiko!',
      testResult: '12 Monate Test: 50€ passiv verdient durch Cloud Mining. App funktioniert, aber Vorsicht – nicht mehr im offiziellen Store verfügbar.',
      payoutProof: true,
      difficulty: 'Mittel',
      setup: '10 Minuten',
      requirements: [
        'Android Smartphone',
        'APK-Installation erlauben',
        'Bitcoin Wallet',
        'Stabile Internetverbindung',
        'Bereitschaft für Risiko (kein offizieller Store)'
      ],
      pros: [
        'Komplett passives Einkommen',
        'Cloud Mining – keine Hardware nötig',
        'Läuft im Hintergrund',
        'Niedrige Einstiegshürde',
        '50€ in 12 Monaten verifiziert'
      ],
      cons: [
        'Aus Play Store entfernt',
        'Nur als APK verfügbar',
        'Nutzung auf eigenes Risiko',
        'Niedrige Erträge',
        'Ungewisse Zukunft der App'
      ],
      detailedReview: {
        setup: 'Die App ist nicht mehr im Google Play Store verfügbar und muss als APK-Datei installiert werden. Dafür musst du in den Android-Einstellungen die Installation aus unbekannten Quellen erlauben. Nach der Installation gibst du deine Bitcoin-Adresse ein und das Cloud Mining startet automatisch. Die Einrichtung dauert etwa 10 Minuten.',
        earnings: 'In 12 Monaten habe ich 50€ komplett passiv verdient – das sind etwa 4€ pro Monat. Das Mining läuft über Cloud-Server, nicht auf deinem Gerät selbst. Die Erträge sind niedrig aber konstant. Für eine App, die einfach im Hintergrund läuft, ist das ein netter Bonus.',
        payout: 'Auszahlungen erfolgen ab 0.001 BTC auf deine Bitcoin-Wallet. Ich habe mehrere Auszahlungen erfolgreich erhalten. Die App zeigt den aktuellen Kontostand transparent an. Bearbeitungszeit war bei mir immer 24-48 Stunden.',
        tips: '• Lade die APK nur von vertrauenswürdigen Quellen herunter\n• Nutze ein separates Gerät oder altes Smartphone\n• Erwarte keine hohen Gewinne – es ist passives Nebeneinkommen\n• Halte die App aktuell, falls Updates verfügbar sind\n• Sichere deine Bitcoin-Wallet-Adresse gut ab',
        conclusion: 'Bitcoin Miner ist eine interessante Option für komplett passives Krypto-Einkommen durch Cloud Mining. Die 50€ in 12 Monaten sind real und verifiziert.\n\nABER: Die App wurde aus dem Play Store entfernt und ist nur noch als APK verfügbar. Das bedeutet ein gewisses Risiko – du weißt nicht genau, was im Code steckt.\n\nMeine Empfehlung: Nur nutzen, wenn du das Risiko verstehst und akzeptierst. Für sicheres Cloud Mining ist GoMining die bessere Wahl. Bitcoin Miner ist eher für Experimentierfreudige, die mit kleinem Einsatz passiv etwas dazuverdienen wollen.'
      }
    }
  ];

  const miningTools = [
    {
      name: 'GoMining',
      description: 'Cloud-Mining Plattform für Bitcoin ohne eigene Hardware',
      logo: 'https://readdy.ai/api/user-upload/1737024088000_gomining.png',
      rating: 4.2,
      earnings: 'ca. 200€',
      difficulty: 'Mittel',
      investment: 'Ab 50€',
      payoutMethods: ['Bitcoin', 'USDT', 'Ethereum'],
      pros: [
        'Keine eigene Hardware nötig',
        'Tägliche Bitcoin-Auszahlungen',
        'Transparente Verträge',
        'Mobile App verfügbar',
        'Verschiedene Mining-Pakete'
      ],
      cons: [
        'Initiales Investment erforderlich',
        'Abhängig vom Bitcoin-Kurs',
        'Langfristige Bindung',
        'Gebühren für Wartung'
      ],
      requirements: [
        'Verifiziertes Konto erforderlich',
        'Krypto-Wallet für Auszahlungen',
        'Grundverständnis für Kryptowährungen'
      ],
      howItWorks: [
        'Registrierung und Verifizierung auf GoMining',
        'Mining-Paket auswählen und kaufen',
        'Automatisches Mining startet sofort',
        'Tägliche Bitcoin-Erträge werden gutgeschrieben',
        'Auszahlung jederzeit auf deine Wallet möglich'
      ],
      tips: [
        'Starte mit einem kleinen Paket zum Testen',
        'Reinvestiere Gewinne für Compound-Effekt',
        'Beobachte den Bitcoin-Kurs für optimale Auszahlungen',
        'Nutze Referral-Programm für Bonus-Einnahmen'
      ],
      conclusion: 'GoMining ist ideal für alle, die in Bitcoin-Mining einsteigen wollen ohne eigene Hardware zu kaufen. Die Plattform ist seriös, transparent und bietet tägliche Auszahlungen. Perfekt für langfristige passive Einnahmen.',
      refLink: 'https://gmt.io/r/AQVVVVVV',
      refLinkText: 'Jetzt GoMining ausprobieren',
      color: 'from-orange-400 to-red-400'
    },
    {
      name: 'Bitcoin Miner',
      description: 'Mobile App zum Mining von Bitcoin direkt auf dem Smartphone',
      logo: 'https://readdy.ai/api/user-upload/1737024088000_bitcoinminer.png',
      rating: 3.5,
      earnings: 'ca. 12€',
      difficulty: 'Sehr einfach',
      investment: 'Kostenlos',
      payoutMethods: ['Bitcoin'],
      pros: [
        'Einfache Installation',
        'Läuft im Hintergrund',
        'Kostenloser Start'
      ],
      cons: [
        'Sehr niedrige Erträge',
        'Hoher Akkuverbrauch',
        'Langsame Mining-Geschwindigkeit'
      ],
      requirements: [
        'Android Smartphone',
        'Stabile Internetverbindung',
        'Bitcoin Wallet'
      ],
      howItWorks: [
        'App aus dem Play Store installieren',
        'Bitcoin-Adresse eingeben',
        'Mining im Hintergrund laufen lassen',
        'Erträge sammeln bis zur Auszahlungsgrenze'
      ],
      tips: [
        'Nutze ein altes Smartphone',
        'Lade das Gerät regelmäßig',
        'Erwarte keine hohen Gewinne'
      ],
      conclusion: 'Gut zum Ausprobieren, aber nicht profitabel als Haupteinnahmequelle.',
      refLink: '',
      refLinkText: '',
      color: 'from-teal-400 to-cyan-400'
    }
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'verified': return 'text-green-400 bg-green-900/30';
      case 'active': return 'text-blue-400 bg-blue-900/30';
      case 'paused': return 'text-yellow-400 bg-yellow-900/30';
      default: return 'text-gray-400 bg-gray-900/30';
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'verified': return 'Verifiziert';
      case 'active': return 'Aktiv';
      case 'paused': return 'Pausiert';
      default: return 'Inaktiv';
    }
  };

  const getDifficultyColor = (difficulty: string) => {
    switch (difficulty) {
      case 'Sehr einfach': return 'text-green-400';
      case 'Einfach': return 'text-teal-400';
      case 'Mittel': return 'text-yellow-400';
      case 'Schwer': return 'text-red-400';
      default: return 'text-gray-400';
    }
  };

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <i 
        key={i} 
        className={`ri-star-${i < Math.floor(rating) ? 'fill' : i < rating ? 'half-fill' : 'line'} text-yellow-400`}
      ></i>
    ));
  };

  const openDetailModal = (app: any) => {
    setSelectedApp(app);
    setShowDetailModal(true);
    document.body.style.overflow = 'hidden';
  };

  const closeDetailModal = () => {
    setShowDetailModal(false);
    setSelectedApp(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <div className="min-h-screen bg-gray-950">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 px-4 sm:px-6 lg:px-8">
        <div className="absolute inset-0 bg-gradient-to-br from-teal-900/20 to-cyan-900/20"></div>
        <div className="relative max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Mining & Passive Tools
            <span className="block text-2xl md:text-3xl text-teal-400 font-normal mt-2">
              Verdiene passiv mit deiner Hardware
            </span>
          </h1>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Getestete Tools für passives Einkommen. Von Bandwidth-Sharing bis GPU-Mining - mit echten Einnahmen und ehrlichen Bewertungen.
          </p>
        </div>
      </section>

      {/* Verified Apps Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center bg-green-900/30 text-green-400 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-shield-check-line mr-2"></i>
              Verifiziert & Getestet
            </div>
            <h2 className="text-3xl font-bold text-white mb-4">Bewährte Apps mit Proof</h2>
            <p className="text-gray-300 max-w-2xl mx-auto">
              Diese Apps wurden von mir persönlich über Monate getestet. Mit echten Einnahmen-Nachweisen und detaillierten Erfahrungsberichten.
            </p>
          </div>

          {testedApps.length === 0 ? (
            <div className="text-center py-16">
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-gray-800/50 rounded-full">
                <i className="ri-apps-line text-3xl text-gray-400"></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">Keine Apps verfügbar</h3>
              <p className="text-gray-400">Hier werden bald getestete Mining & Passive Income Apps angezeigt.</p>
            </div>
          ) : (
            <div className="grid lg:grid-cols-2 gap-8 mb-16">
              {testedApps.map((app, index) => (
                <div key={index} className="bg-gray-900/50 border-2 border-green-700/50 rounded-xl overflow-hidden hover:border-green-600/70 transition-all duration-300 shadow-lg shadow-green-900/20">
                  <div className="relative">
                    <img 
                      src={app.image} 
                      alt={`${app.name} Interface`}
                      className="w-full h-48 object-cover object-top"
                    />
                    <div className="absolute top-4 left-4">
                      <div className={`px-3 py-1 rounded-full text-xs font-bold ${getStatusColor(app.status)}`}>
                        <i className="ri-shield-check-line mr-1"></i>
                        {getStatusText(app.status)}
                      </div>
                    </div>
                    <div className="absolute top-4 right-4">
                      <div className="bg-gray-900/80 text-white px-2 py-1 rounded text-xs">
                        {app.type}
                      </div>
                    </div>
                    <div className="absolute bottom-4 right-4">
                      <div className="flex items-center bg-gray-900/80 text-white px-2 py-1 rounded">
                        {renderStars(app.rating)}
                        <span className="ml-2 text-xs">{app.rating}</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-2xl font-bold text-white">{app.name}</h3>
                      <div className="text-right">
                        <div className="text-xl font-bold text-green-400">{app.earnings}</div>
                        <div className="text-xs text-gray-400">{app.timeframe}</div>
                      </div>
                    </div>
                    
                    <p className="text-gray-300 mb-4">{app.description}</p>
                    
                    {/* Test Result */}
                    <div className="bg-green-900/20 border border-green-700/30 rounded-lg p-4 mb-4">
                      <div className="flex items-center mb-2">
                        <i className="ri-test-tube-line text-green-400 mr-2"></i>
                        <span className="text-green-400 font-semibold text-sm">Testergebnis</span>
                        {app.payoutProof && (
                          <div className="ml-auto flex items-center text-green-400 text-xs">
                            <i className="ri-money-dollar-circle-line mr-1"></i>
                            Auszahlung bestätigt
                          </div>
                        )}
                      </div>
                      <p className="text-gray-300 text-sm">{app.testResult}</p>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-4 mb-4">
                      <div>
                        <div className="text-xs text-gray-400 mb-1">Schwierigkeit</div>
                        <div className={`text-sm font-semibold ${getDifficultyColor(app.difficulty)}`}>
                          {app.difficulty}
                        </div>
                      </div>
                      <div>
                        <div className="text-xs text-gray-400 mb-1">Setup-Zeit</div>
                        <div className="text-sm font-semibold text-white">{app.setup}</div>
                      </div>
                    </div>
                    
                    <div className="space-y-4 mb-6">
                      <div>
                        <div className="text-sm font-semibold text-white mb-2">Voraussetzungen:</div>
                        <ul className="text-xs text-gray-300 space-y-1">
                          {app.requirements.map((req: string, i: number) => (
                            <li key={i}>• {req}</li>
                          ))}
                        </ul>
                      </div>
                      
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <div className="text-green-400 text-xs font-semibold mb-1">PROS:</div>
                          <ul className="text-xs text-gray-300 space-y-1">
                            {app.pros.map((pro: string, i: number) => (
                              <li key={i}>• {pro}</li>
                            ))}
                          </ul>
                        </div>
                        <div>
                          <div className="text-red-400 text-xs font-semibold mb-1">CONS:</div>
                          <ul className="text-xs text-gray-300 space-y-1">
                            {app.cons.map((con: string, i: number) => (
                              <li key={i}>• {con}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                    
                    <div className="flex">
                      <button
                        onClick={() => openDetailModal(app)}
                        className="inline-flex items-center justify-center font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap bg-gradient-to-r from-teal-400 to-cyan-400 text-gray-900 hover:from-teal-300 hover:to-cyan-300 shadow-lg hover:shadow-xl px-4 py-2 text-sm rounded-lg w-full"
                      >
                        <i className="ri-guide-line mr-2"></i>
                        Detaillierter Test
                      </button>
                    </div>
                    {app.name === 'GoMining' && (
                      <div className="flex mt-3">
                        <a
                          href="https://gomining.com/?ref=9EtLZ"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center justify-center font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap bg-gradient-to-r from-orange-400 to-red-400 text-white hover:from-orange-300 hover:to-red-300 shadow-lg hover:shadow-xl px-4 py-2 text-sm rounded-lg w-full"
                        >
                          <i className="ri-external-link-line mr-2"></i>
                          Jetzt GoMining ausprobieren
                        </a>
                      </div>
                    )}
                    {app.name === 'Bitcoin Miner - Code: 2UNE5W' && (
                      <div className="flex mt-3">
                        <a
                          href="https://bitcoinlucky.xyz/apk/bitcoin_mining_4.6.2.apk"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center justify-center font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap bg-gradient-to-r from-yellow-500 to-orange-500 text-white hover:from-yellow-400 hover:to-orange-400 shadow-lg hover:shadow-xl px-4 py-2 text-sm rounded-lg w-full"
                        >
                          <i className="ri-download-line mr-2"></i>
                          APK herunterladen (auf eigene Gefahr)
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Stats Overview */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 border-y border-gray-800">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-400 mb-2">ca. 250€</div>
              <div className="text-gray-400 text-sm">Gesamt verdient</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-green-400 mb-2">2</div>
              <div className="text-gray-400 text-sm">Test Apps</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-400 mb-2">24/7</div>
              <div className="text-gray-400 text-sm">Passive Einnahmen</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-400 mb-2">12</div>
              <div className="text-gray-400 text-sm">Monate Erfahrung</div>
            </div>
          </div>
        </div>
      </section>

      {/* Warning Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-yellow-900/10 border-y border-yellow-800/30">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-yellow-900/30 rounded-full">
            <i className="ri-error-warning-line text-3xl text-yellow-400"></i>
          </div>
          <h2 className="text-3xl font-bold text-white mb-4">Wichtige Hinweise</h2>
          <div className="text-left space-y-4 text-gray-300">
            <p>
              <strong className="text-yellow-400">Stromkosten beachten:</strong> Mining und Computing-Tools können deinen Stromverbrauch erheblich erhöhen. Rechne immer die Kosten gegen die Einnahmen.
            </p>
            <p>
              <strong className="text-yellow-400">Hardware-Verschleiß:</strong> Intensive Nutzung kann die Lebensdauer deiner Hardware verkürzen. Besonders bei GPU-Mining.
            </p>
            <p>
              <strong className="text-yellow-400">Schwankende Einnahmen:</strong> Passive Income Tools haben unvorhersagbare Einnahmen. Sieh es als Bonus, nicht als Haupteinkommen.
            </p>
            <p>
              <strong className="text-yellow-400">Datenschutz:</strong> Bei Bandwidth-Sharing teilst du deine Internetverbindung. Informiere dich über die Nutzung deiner Daten.
            </p>
          </div>
        </div>
      </section>

      {/* Detail Modal */}
      {showDetailModal && selectedApp && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
          <div className="bg-gray-900 rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="sticky top-0 bg-gray-900 border-b border-gray-700 p-6 flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <img 
                  src={selectedApp.image} 
                  alt={selectedApp.name}
                  className="w-16 h-16 rounded-lg object-cover"
                />
                <div>
                  <h2 className="text-2xl font-bold text-white">{selectedApp.name}</h2>
                  <div className="flex items-center space-x-2">
                    {renderStars(selectedApp.rating)}
                    <span className="text-gray-400 text-sm">({selectedApp.rating})</span>
                  </div>
                </div>
              </div>
              <button 
                onClick={closeDetailModal}
                className="text-gray-400 hover:text-white transition-colors"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6 space-y-8">
              {/* Setup */}
              <div>
                <h3 className="text-xl font-bold text-white mb-4 flex items-center">
                  <i className="ri-settings-3-line text-teal-400 mr-2"></i>
                  Setup & Installation
                </h3>
                <div className="bg-gray-800/50 rounded-lg p-4">
                  <p className="text-gray-300 leading-relaxed">{selectedApp.detailedReview.setup}</p>
                </div>
              </div>

              {/* Earnings */}
              <div>
                <h3 className="text-xl font-bold text-white mb-4 flex items-center">
                  <i className="ri-money-dollar-circle-line text-green-400 mr-2"></i>
                  Einnahmen & Performance
                </h3>
                <div className="bg-green-900/20 border border-green-700/30 rounded-lg p-4">
                  <p className="text-gray-300 leading-relaxed">{selectedApp.detailedReview.earnings}</p>
                </div>
              </div>

              {/* Payout */}
              <div>
                <h3 className="text-xl font-bold text-white mb-4 flex items-center">
                  <i className="ri-bank-card-line text-blue-400 mr-2"></i>
                  Auszahlungen & Proof
                </h3>
                <div className="bg-blue-900/20 border border-blue-700/30 rounded-lg p-4">
                  <p className="text-gray-300 leading-relaxed">{selectedApp.detailedReview.payout}</p>
                </div>
              </div>

              {/* Tips */}
              <div>
                <h3 className="text-xl font-bold text-white mb-4 flex items-center">
                  <i className="ri-lightbulb-line text-yellow-400 mr-2"></i>
                  Tipps & Tricks
                </h3>
                <div className="bg-yellow-900/20 border border-yellow-700/30 rounded-lg p-4">
                  <p className="text-gray-300 leading-relaxed">{selectedApp.detailedReview.tips}</p>
                </div>
              </div>

              {/* Conclusion */}
              <div>
                <h3 className="text-xl font-bold text-white mb-4 flex items-center">
                  <i className="ri-check-double-line text-purple-400 mr-2"></i>
                  Fazit & Empfehlung
                </h3>
                <div className="bg-purple-900/20 border border-purple-700/30 rounded-lg p-4">
                  <p className="text-gray-300 leading-relaxed">{selectedApp.detailedReview.conclusion}</p>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex space-x-4 pt-4">
                {selectedApp.name === 'GoMining' && (
                  <a 
                    href="https://gomining.com/?ref=9EtLZ"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1"
                  >
                    <Button variant="primary" className="w-full">
                      <i className="ri-external-link-line mr-2"></i>
                      Jetzt GoMining ausprobieren
                    </Button>
                  </a>
                )}
                {selectedApp.name === 'Bitcoin Miner - Code: 2UNE5W' && (
                  <a 
                    href="https://bitcoinlucky.xyz/apk/bitcoin_mining_4.6.2.apk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1"
                  >
                    <Button variant="primary" className="w-full">
                      <i className="ri-download-line mr-2"></i>
                      APK herunterladen (auf eigenes Risiko)
                    </Button>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
